import { TranslationsMap } from '../translations.map';

export const frCALocale: TranslationsMap = {
  // Common
  account_header: 'Compte',
  overview: 'Aperçu',
  profile: 'Profil',
  sign_out: 'Se déconnecter',
  save: 'Enregistrer',
  days: 'Jours',
  weeks: 'Semaines',
  cancel: 'Annuler',
  save_changes: 'Sauvegarder les modifications',
  general_information: 'Informations générales',
  enabled: 'Activé',
  disabled: 'Désactivé',
  confirm: 'Confirmer',
  error: 'Erreur',
  learn_more: 'En savoir plus',
  about: 'À propos',

  // Overview
  welcome_user: 'Bienvenue, {{name}}!',
  organization_header: 'Organisations',
  organizational_units_header: 'Unités organisationnelles',
  studies_header: 'Études',
  data_sources_header: 'Sources de données',
  admins_header: 'Administrateurs',
  first_name_header: 'Prénom',
  last_name_header: 'Nom de famille',
  role_header: 'Rôles',
  participants_header: 'Participants',
  name_header: 'Nom',
  display_name_header: 'Nom d’affichage',
  created_header: 'Créé',
  joined_header: 'A rejoint',
  researchers_header: 'Chercheurs',
  email_header: 'Courriel',
  phone_number_header: 'Numéro de téléphone',

  admin: 'Administrateur',
  researcher: 'Chercheur',
  users: 'Utilisateurs',
  manager: 'Gestionnaire',

  study: 'Étude',
  data_source: 'Source de données',

  error_loading_overview: 'Erreur lors de la récupération de le compte',
  error_getting_organization: 'Erreur lors de la récupération de l’organisation',
  error_getting_study: 'Erreur lors de la récupération de l’étude',

  num_participants: 'participants',
  num_researchers: 'chercheurs',
  num_studies: 'études',
  num_organizational_units: 'unités organisationnelles',
  num_data_sources: 'sources de données',

  organization_name: 'Nom de l’organisation',
  edit_organization: 'Modifier l’organisation',
  actions: 'Actions',
  create_study: 'Créer une étude',
  creation_date: 'Date de création',
  organization_overview: 'Aperçu de l’organisation',
  organization_updated_successfully: '{{name}} a été mis à jour avec succès 🎉',

  success_invitation_code_refreshed: "Le code d'invitation a été actualisé avec succès 🎉",
  success_invitation_code_copied: 'Le code d’invitation a été copié dans le presse-papiers',
  copy_invitation_code: 'Copier le code d’invitation',
  refresh_invitation_code: 'Actualiser le code d’invitation',
  edit_study: 'Modifier l’étude',

  invite_researcher: 'Inviter un chercheur',
  researcher_invited_successfully: 'Chercheur invité avec succès',
  invite: 'Inviter',

  example_num: 'Ex. 10',
  study_updated_successfully: '{{name}} a été mis à jour avec succès 🎉',
  study_name: 'Nom de l’étude',
  description: 'Description',
  expected_total_participants: 'Nombre total de participants prévu',
  expected_time_in_study: 'Durée prévue dans l’étude',
  expected_participant_duration_in_study: 'Durée prévue par participant dans l’étude',
  start_date: 'Date de début',
  completion_date: 'Date de fin',
  no_participants_in_study: 'Aucun participant ne s’est joint à cette étude',

  create_study_for: 'Créer une étude pour {{name}}',
  expected_participants: 'Participants prévus',
  enter_study_description: 'Entrez la description de l’étude',

  edit_data_source: 'Modifier la source de données',
  delete_data_source: 'Supprimer la source de données',
  no_description_provided: 'Aucune description fournie',

  no_researchers_assigned_to_this_study: 'Aucun chercheur assigné à cette étude.',
  no_researchers_assigned_to_this_data_source: 'Aucun chercheur assigné à cette source de données.',

  unassign_researcher: 'Désassigner le chercheur',
  unassign_researcher_from_data_source_confirmation:
    'Êtes-vous sûr de vouloir désassigner ce chercheur de la source de données {{name}} (ID: {{id}})',
  unassign_researcher_from_study_confirmation:
    "Êtes-vous sûr de vouloir désassigner ce chercheur de l'étude {{name}} (ID: {{id}})",
  user_assigned_to_entity: 'Utilisateur assigné à {{entityName}}',
  assign_researcher: 'Assigner un chercheur',
  assign_researcher_confirmation:
    'Assigner cet utilisateur à {{selectedEntityType}} lui donnera accès à toutes les données et fonctionnalités de {{selectedEntityType}}. Êtes-vous sûr de vouloir continuer?',
  assign_to_study_or_data_source: "Assigner à l'étude ou à la source de données",

  find_entities: 'Trouver des entités',
  no_studies_found: 'Aucune étude trouvée',
  no_data_sources_found: 'Aucune source de données trouvée',

  organization_wide_access: "Accès à l'ensemble de l'organisation",
  confirm_modifying_organization_wide_access:
    "Confirmer la modification de l'accès à l'ensemble de l'organisation",
  disable_organization_wide_access_confirmation:
    "Êtes-vous sûr de vouloir désactiver l'accès à l'ensemble de l'organisation? Cela révoquera l'accès de tous les chercheurs à toutes les études et sources de données de l'organisation. Les chercheurs ne pourront accéder qu'aux études et sources de données qui leur ont été explicitement assignées.",
  enable_organization_wide_access_confirmation:
    "Êtes-vous sûr de vouloir activer l'accès à l'ensemble de l'organisation? Cela donnera à tous les chercheurs accès à toutes les études et sources de données de l'organisation.",
  note_change_not_saved_until_click_save:
    "Remarque: cette modification ne sera pas enregistré tant que vous n'aurez pas cliqué sur le bouton Enregistrer.",

  no_organizational_units_created:
    'Aucune unité organisationnelle n’a été créée pour cette organisation',
  no_researchers_created: 'Aucun chercheur n’a été créé pour cette organisation',
  no_data_sources_created: 'Aucune source de données n’a été créée pour cette organisation',
  no_studies_created: 'Aucune étude n’a été créée pour cette organisation',
  error_fetching_organizations:
    'Une erreur est survenue lors de la récupération de vos organisations',

  no_org_assigned: 'Vous n’avez pas encore été assigné à une organisation',
  request_admin_to_join_org:
    'Pour rejoindre une organisation, veuillez demander l’accès à votre administrateur',
  contact_administrator: 'Contacter l’administrateur',

  // Profile
  my_profile: 'Mon profil',
  profile_info: 'Informations du profil',
  change_password: 'Changer le mot de passe',

  new_passwords_dont_match: 'Le nouveau mot de passe et la confirmation doivent correspondre',
  success_password_reseted: 'Réinitialisation du mot de passe réussie 🎉',
  old_password: 'Ancien mot de passe',
  new_password: 'Nouveau mot de passe',
  confirm_password: 'Confirmer le mot de passe',

  success_profile_updated: 'Mise à jour du profil réussie 🎉',
  email_phone_verified: 'Votre {{attribute}} a été vérifié avec succès 🎉',
  email: 'courriel',
  phone_number: 'numéro de téléphone',
  verification_sent: 'Un code de vérification a été envoyé à votre {{attribute}}',
  basic_information: 'Informations de base',
  information_only_visible_to_you: 'Ces informations ne sont visibles que par vous',
  error_loading_profile: 'Erreur lors du chargement du profil',
  error_editing_profile: 'Erreur lors de la modification du profil',
  last_updated: 'Dernière mise à jour',
  user_roles: "Rôles de l'utilisateur",
  edit: 'Modifier',
  verify_your: 'Vérifiez votre {{attribute}}',

  verify_header: 'Vérifier',
  please_enter_verification_sent:
    'Veuillez entrer le code de vérification envoyé à votre {{attribute}}',

  enter_verification_code: 'Entrez le code de vérification',
  resend_verification_code: 'Renvoyer le code de vérification',

  // Not found
  oops_page_not_found: 'Oups! Page non trouvée.',
  could_not_find_page: 'Nous n’avons pas trouvé la page que vous recherchez.',
  back_to_home_page: 'Retour à la page d’accueil',

  // Create Cohort Builder
  create_cohort_builder: 'Créer un générateur de cohortes',
  create_cohort: 'Créer une cohorte',
  no_cohorts_created: 'Aucune cohorte créée',
  no_cohorts_created_description:
    'Les cohortes vous permettent de définir et de gérer des sous-ensembles de vos données pour un analyse ciblée. Créez votre première cohorte pour commencer.',

  // Dataset
  data: 'Données',

  // Dataset Overview
  time_span: 'Période',
  record_count: 'Nombre de records',
  data_provider: 'Fournisseur de données',
  data_dictionary: 'Dictionnaire de données',
  completeness_score: 'Score de complétude',
  column_name: 'Nom de la colonne',
  data_dictionary_description: 'Dictionnaire de données',
  column_type: 'Type de données',
  column_description: 'Description de la colonne',
  column_completeness_score: 'Score de complétude de la colonne',
  select_table: 'Sélectionner une table',
  search_column_name_type_description: 'Rechercher par nom de colonne, type ou description',

  // Dataset Cohort

  cohort: 'Cohorte',
  search_cohort: 'Rechercher par nom',
  action_create_cohort: 'Créer une cohorte',
  cohort_column_name_header: 'Nom de la colonne',
  cohort_column_owner_header: 'Propriétaire',
  cohort_column_description_header: 'Description',
  cohort_column_patient_count_header: 'Patients',

  // Dataset Codes
  no_codes_created: 'Aucun code créé',
  no_codes_created_description:
    'Les codes vous permettent de définir et de gérer des sous-ensembles de vos données pour une analyse ciblée. Créez votre premier code pour commencer.',

  // Complete Account Creation
  create_your_account: 'Créez votre compte',
  complete_your_account_details:
    'Complétez les informations de votre compte pour commencer à explorer Medeloop',
  enter_given_name: 'Entrez votre prénom',
  enter_family_name: 'Entrez votre nom de famille',
  enter_phone_number: 'Entrez votre numéro de téléphone',
  to_change_use_sso_provider: 'Pour modifier {{field}}, utilisez votre fournisseur SSO',
  given_name: 'Prénom',
  family_name: 'Nom de famille',
  continue: "Continuer",
  something_wrong_authentication: "Une erreur s'est produite lors de l'authentification",
  something_went_wrong: "Une erreur s'est produite",
  code_inserted_wrong: 'Le code inséré est incorrect',
  enter_code_to_destination: 'Entrez le code qui a été envoyé par SMS à : {{destination}}',
};
